import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-checkNo",
  "use": "icon-checkNo-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol viewBox=\"0 0 16 16\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-checkNo\">\n<path d=\"M13 13V15H3V13H13ZM13 3H3V15L2.7959 14.9893C1.85435 14.8938 1.1062 14.1457 1.01074 13.2041L1 13V3C1 1.96435 1.78722 1.113 2.7959 1.01074L3 1H13L13.2041 1.01074C14.2128 1.113 15 1.96435 15 3V13L14.9893 13.2041C14.8938 14.1457 14.1457 14.8938 13.2041 14.9893L13 15V3Z\" fill=\"#242333\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol